import { Typography } from '@mui/material';
import {
  isLink,
  isList,
  isParagraph,
  Record as DatoRecord,
} from 'datocms-structured-text-utils';
import {
  renderMarkRule,
  renderNodeRule,
  StructuredText,
  StructuredTextGraphQlResponse,
} from 'react-datocms';

import { isNodeEmpty } from 'utils/structured-text.utils';

import { LinkProps } from 'components/@common/Link';
import StructuredLink from 'components/@structured/StructuredLink';

interface Props<R extends DatoRecord> {
  variant?: LinkProps['variant'];
  content: StructuredTextGraphQlResponse<R>;
}

const BasicText = <R extends DatoRecord = DatoRecord>({
  content,
  variant,
}: Props<R>) => {
  const CUSTOM_NODE_RULES = [
    renderNodeRule(isParagraph, ({ children, node, key }) => {
      if (isNodeEmpty(node)) return <br key={key} />;

      return (
        <Typography component="p" key={key} variant={variant}>
          {children}
        </Typography>
      );
    }),
    renderNodeRule(isLink, ({ key, node, children }) => (
      <StructuredLink key={key} node={node} variant={variant}>
        {children}
      </StructuredLink>
    )),
    renderNodeRule(isList, ({ key, node, children }) => {
      if (node.style === 'bulleted') {
        return (
          <Typography component="ul" key={key} variant={variant}>
            {children}
          </Typography>
        );
      } else
        return (
          <Typography component="ol" key={key} variant={variant}>
            {children}
          </Typography>
        );
    }),
  ];

  const CUSTOM_MARK_RULES = [
    renderMarkRule('strong', ({ children, key }) => (
      <strong key={key}>{children}</strong>
    )),
    renderMarkRule('italic', ({ children, key }) => (
      <i key={key}>{children}</i>
    )),
  ];

  return (
    <StructuredText
      data={content}
      customNodeRules={CUSTOM_NODE_RULES}
      customMarkRules={CUSTOM_MARK_RULES}
    />
  );
};

export default BasicText;
